// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root___B0LA","left":"InfoRow_left__38kQH"};